import React from 'react';
import { CheckCircleIcon, MinusCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import {
  ACCOUNT_PASSWORD_POLICY_COPY,
  AccountPasswordValidation,
  getPasswordPolicyHints,
} from '../../services/accountSecurity';

interface PasswordPolicyChecklistProps {
  password: string;
  validation?: AccountPasswordValidation;
  className?: string;
  showCopy?: boolean;
}

const PasswordPolicyChecklist: React.FC<PasswordPolicyChecklistProps> = ({
  password,
  validation,
  className = '',
  showCopy = true,
}) => {
  const requirements = getPasswordPolicyHints(validation, password);
  const hasPassword = password.length > 0;

  return (
    <div
      className={`rounded-lg border border-primary-dark-300/42 bg-primary-dark-100/30 p-3 ${className}`}
      aria-live="polite"
    >
      {showCopy && (
        <p className="text-xs leading-5 text-primary-light-300 sm:text-sm">
          {ACCOUNT_PASSWORD_POLICY_COPY}
        </p>
      )}
      <ul className="mt-3 grid gap-2 text-xs sm:grid-cols-2 sm:text-sm">
        {requirements.map((requirement) => {
          const stateClass = !hasPassword
            ? 'text-primary-light-400'
            : requirement.met
              ? 'text-status-success-400'
              : 'text-primary-light-300';
          const Icon = !hasPassword
            ? MinusCircleIcon
            : requirement.met
              ? CheckCircleIcon
              : XCircleIcon;

          return (
            <li key={requirement.key} className={`flex min-w-0 items-center gap-2 ${stateClass}`}>
              <Icon className="h-4 w-4 flex-none" aria-hidden="true" />
              <span className="min-w-0 leading-5">{requirement.label}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PasswordPolicyChecklist;
